import { render, staticRenderFns } from "./GroupFinancialTransfer.vue?vue&type=template&id=ddbccdf0&scoped=true"
import script from "./GroupFinancialTransfer.vue?vue&type=script&lang=js"
export * from "./GroupFinancialTransfer.vue?vue&type=script&lang=js"
import style0 from "./GroupFinancialTransfer.vue?vue&type=style&index=0&id=ddbccdf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbccdf0",
  null
  
)

export default component.exports